const ACCESS_KEY = "sporush_admin_access";
const REFRESH_KEY = "sporush_admin_refresh";
const USER_KEY = "sporush_admin_user";
const COOKIE_NAME = "sporush_admin_access";

import type { AdminUser } from "./types";

function isBrowser(): boolean {
  return typeof window !== "undefined";
}

export function getAccessToken(): string | null {
  if (!isBrowser()) return null;
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
  if (!isBrowser()) return null;
  return localStorage.getItem(REFRESH_KEY);
}

export function getStoredAdmin(): AdminUser | null {
  if (!isBrowser()) return null;
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AdminUser;
  } catch {
    return null;
  }
}

function setCookie(token: string, maxAgeSeconds: number) {
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(token)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
}

function clearCookie() {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
}

export function persistSession(
  accessToken: string,
  refreshToken: string,
  admin: AdminUser,
  expiresIn: number,
) {
  localStorage.setItem(ACCESS_KEY, accessToken);
  localStorage.setItem(REFRESH_KEY, refreshToken);
  localStorage.setItem(USER_KEY, JSON.stringify(admin));
  setCookie(accessToken, expiresIn);
}

export function clearSession() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
  clearCookie();
}

export function isSuperAdmin(admin: AdminUser | null): boolean {
  return admin?.role === "super_admin";
}
